/** Every portal route. Pages register in `src/router.tsx`. */
export enum ScreenRoutes {
  HOME = '/',
  SIGNIN = '/auth/signin',
  SIGNUP = '/auth/signup',
  RESET_PASSWORD = '/auth/reset-password',
  ACTIVATE_ACCOUNT = '/auth/activate',
  ONBOARDING = '/onboarding',
  EVENTS = '/events',
  EVENT_NEW = '/events/new',
  EVENT_DETAIL = '/events/:eventId',
  EVENT_EDIT = '/events/:eventId/edit',
  OFFERS = '/offers',
  OFFER_NEW = '/offers/new',
  OFFER_DETAIL = '/offers/:offerId',
  OFFER_EDIT = '/offers/:offerId/edit',
  RESULTS = '/results',
  /** "Seus links": the partner's tracked links (docs/admin/acquisition.md). */
  LINKS = '/links',
  INTEGRATION = '/integration',
  ACCOUNT = '/account',
  ACCOUNT_EDIT = '/account/edit',
  /** Link of the partner invite e-mail (`{PARTNERS_URL}/invite/{token}`), signed in or out. */
  INVITE = '/invite/:token',
}
